import React from "react";
import { NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const projects = [
  {
    image: require("../../images/projects/image1.jpg"),
    title: "Projet Vallée Val d’Or 1",
    description:
      "Le Projet « VAL D’OR 1 », qui s’étale sur une superficie de 3 hectares environ, est initié par l’association la Vallée en partenariat avec  une amicale ayant les mêmes objectifs.",
  },
  {
    image: require("../../images/projects/image2.jpg"),
    title: "Projet Vallée Val d’Or 2",
    description:
      "Le Projet « VAL D’OR 2 », qui s’étale sur une superficie de 3 hectares environ, est initié par l’association la Vallée en partenariat avec  une amicale ayant les mêmes objectifs.",
  },
  {
    image: require("../../images/projects/image3.jpg"),
    title: "Projet Vallée Val d’Or 3",
    description:
      "Le Projet « VAL D’OR 3 », qui s’étale sur une superficie de 3 hectares environ, est initié par l’association la Vallée en partenariat avec  une amicale ayant les mêmes objectifs.",
  },
];

var bgimg1 = require("./../../images/background/cross-line2.png");

class Projects3 extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: false,
      center: false,
      items: 3,
      margin: 40,
      nav: true,
      dots: true,
      navText: [
        '<i className="fa fa-angle-left"></i>',
        '<i className="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
          margin: 15,
        },
        640: {
          items: 2,
          margin: 15,
        },
        768: {
          items: 2,
          margin: 15,
        },
        991: {
          items: 3,
          margin: 15,
        },
        1200: {
          items: 3,
        },
      },
    };
    return (
      <>
        <div
          id="ourProjects"
          className={`${this.props.bgcolor} project-list-section section-full p-tb50  inner-page-padding`}
        >
          <div className="container-fluid">
            <div className="section-content">
              {/* TITLE START */}
              <div data-aos-duration="800"  data-aos="fade-up" className="section-head">
                <div className={`${this.props.alignment} sx-separator-outer`}>
                  <div className="sx-separator bg-white bg-moving bg-repeat-x">
                    <h3 className="sep-line-one">{this.props.title}</h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
              <div className="work-carousel-outer">
                <OwlCarousel
                  className="owl-carousel mfp-gallery project-carousel project-carousel3 owl-btn-vertical-center p-lr80"
                  {...options}
                >
                  {projects.map((item, index) => (
                    <div data-aos-duration="800"  data-aos="zoom-in-down" key={index} className="item">
                      <div className="project-mas m-a30">
                        <div className="image-effect">
                          <img src={item.image} alt="" />
                        </div>
                        <div className="project-info p-a20">
                          <h4 className="sx-tilte m-t0">
                            <a href={"/projects/valle-or-1"}>{item.title}</a>
                          </h4>
                          <p>{item.description}</p>
                          <a
                            href={"/projects/valle-or-1"}
                            className="site-button btn-half button-sm m-t20"
                            style={{ background: "#fff" }}
                          >
                            <span style={{ color: "#000" }}>Voir plus</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            </div>
          </div>
          {/* <div className="hilite-title text-left p-l50 text-uppercase">
            <strong>Projets</strong>
          </div> */}
        </div>
      </>
    );
  }
}

export default Projects3;
